export const boldSmallTextIconsStyles = {
  fontSize: 14,
  letterSpacing: 0.25,
};

export const contentStyles = theme => ({
  height: '100%',
  padding: theme.spacing(1, 3, 2),
  width: '100%',
});

export const isIconStyles = theme => ({
  color: theme.palette.primary.dark,
  height: 20,
  marginRight: 10,
  width: 20,
});

export const listBoxStyles = theme => ({
  borderTop: `0.1em solid ${theme.palette.graphic.light}`,
  flexShrink: 0,
  margin: `${theme.spacing(1.5)} 0 10px`,
  minHeight: 30,
});

export const locationNameStyles = theme => ({
  marginBottom: theme.spacing(2),
});

export const sectionDivStyles = theme => ({
  borderBottom: `0.1em solid ${theme.palette.graphic.light}`,
  padding: theme.spacing(2, 0),
});

export const sectionTitleStyles = theme => ({
  marginBottom: theme.spacing(0.5),
});

export const statusStyles = props => ({
  color: props.statusTextColor,
  width: 175,
});
